<template>
	<a href="javascript:void(0)" 
		:class="{ 'uk-navbar-item uk-padding-small' : navBarItem }"
		:download="proposed_file_name"
	>
	<div class="uk-grid download uk-grid-small">
		<div class="uk-width-auto uk-text-center">
			<div class="uk-flex uk-flex-middle uk-flex-center">
				<span
					class="material-symbols-outlined"
					@click="downloadFile">
					<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M280-280h400v-80H280v80Zm200-120 160-160-56-56-64 62v-166h-80v166l-64-62-56 56 160 160Zm0 320q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
				</span>
				<span v-show="showUpVote" class="text uk-margin-xsmall-left">
			 	{{ text }}
				</span>
			</div>
		</div>
	</div>
	</a>	
</template>

<script>

export default {
	name: "downloadIcon",
	props: {
		url: {
			type: String,
			required: true,
		},
		icon: {
			type: String,
			default: 'download'
		},
		text: {
			type: String,
			default: null
		},
		navBarItem: {
			type: Boolean,
			required: false,
			default: false
		}			
	},
	mounted() {
		//this.$root.$logger('app/component/download-icon/mounted')
	},
	methods: {
		downloadFile() {
			this.$root.$logger('app/component/download-icon/download-file')
			
			var component = this;
			var url = component.url;
			var params = {
				action: "downloadFile",
				fileData: {
					url: url,
				},
			};
									
			if(component.$root.device.app) {
				this.$helper.sendAppMessage(params);				
			} else {
				window.open(url)
			}
		}
	},
}
				
</script>